import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import WrapperPage from "../../components/WrapperPage";
import BaseButton from "../../components/BaseButton";
import BaseIcon from "../../components/BaseIcon";
import InsightFormProtect from "../../hocs/InsightFormProtect";
import ROUTES from "../../utils/routes.js";
import "./style.scss";

export default InsightFormProtect(function InsightFormRecommendationPairPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="insight_form_recommendation_pair_page centering-page">
      <WrapperPage
        backBtn
        burgerMenu
        headerTitle={t("insight_form_recommendation_pair_page.title")}
      >
        <div className="insight_form_recommendation_pair_page__top-texts">
          <div className="insight_form_recommendation_pair_page__left-texts">
            <div>
              {t("insight_form_recommendation_pair_page.leftSide.desc1")}
            </div>
            <div>
              {t("insight_form_recommendation_pair_page.leftSide.desc2")}
            </div>
          </div>
          <div className="insight_form_recommendation_pair_page__right-texts">
            <BaseIcon name="arrow_right" />
            <div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {t("insight_form_recommendation_pair_page.rightSide.desc1")}
            </div>
            <div>
              {t("insight_form_recommendation_pair_page.rightSide.desc2")}
            </div>
          </div>
        </div>
        <div className="insight_form_recommendation_pair_page__center-text">
          {t("insight_form_recommendation_pair_page.centerText")}
        </div>
        <div className="insight_form_recommendation_pair_page__useless-texts">
          <div>
            {t("insight_form_recommendation_pair_page.uselessText.text1")}
          </div>
          <div>
            {t("insight_form_recommendation_pair_page.uselessText.text2")}
          </div>
          <div>
            {t("insight_form_recommendation_pair_page.uselessText.text3")}
          </div>
          <div>
            {t("insight_form_recommendation_pair_page.uselessText.text4")}
          </div>
          <div>
            {t("insight_form_recommendation_pair_page.uselessText.text6")}
          </div>
          <div>
            {t("insight_form_recommendation_pair_page.uselessText.text7")}
          </div>
        </div>
        <div className="insight_form_recommendation_pair_page__final-text">
          {t("insight_form_recommendation_pair_page.finalText")}
        </div>
        <div className="insight_form_recommendation_pair_page__return-back">
          <BaseButton
            onClick={() => navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE)}
            unfilledGray
          >
            {t("insight_form_recommendation_pair_page.return_back")}
          </BaseButton>
        </div>
      </WrapperPage>
    </div>
  );
});
